/*
 * Collapses the mobile search field behind an icon in the header.
 * Paired with assets/header-mobile-search.css and the toggle button in
 * sections/header.liquid.
 *
 * It only shows and hides the row the field already lives in — the field itself,
 * the predictive results and the close button are the vendor's and are untouched,
 * so search behaves exactly as it does on desktop once it is open.
 */

(function () {
  'use strict';

  var OPEN_CLASS = 'mobile-search-open';

  function init(toggle) {
    var header = toggle.closest('.header__top');
    if (!header) return;

    var search = header.querySelector('.header__search');
    if (!search) return;

    var input = search.querySelector('input[type="search"]');
    var predictive = search.querySelector('predictive-search');
    var closeButton = search.querySelector('.header__search-close');

    function isOpen() {
      return header.classList.contains(OPEN_CLASS);
    }

    function open() {
      header.classList.add(OPEN_CLASS);
      toggle.setAttribute('aria-expanded', 'true');

      // Focusing is what opens the predictive panel — the vendor element listens
      // for focus, not for a class. It also raises the keyboard, which is the
      // point of tapping a search icon.
      if (input) input.focus();
    }

    function close() {
      if (!isOpen()) return;

      header.classList.remove(OPEN_CLASS);
      toggle.setAttribute('aria-expanded', 'false');

      /*
       * Hand the vendor element its own close path rather than just hiding the
       * row. `search-open` on <body> is what draws the full-screen overlay
       * (.search-open .header-section .fixed-overlay in theme.css), and hiding
       * the field without clearing it leaves the overlay up with nothing behind
       * it. Guarded so a vendor update that renames the method degrades to a
       * stuck overlay rather than a thrown error that breaks the toggle.
       */
      if (predictive && typeof predictive.toggleSearchState === 'function') {
        predictive.toggleSearchState(false);
      }

      if (input) input.blur();
    }

    toggle.addEventListener('click', function () {
      if (isOpen()) {
        close();
      } else {
        open();
      }
    });

    if (closeButton) closeButton.addEventListener('click', close);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });

    // The vendor dispatches this when the navigation drawer opens, and it
    // already closes the predictive panel on it. Collapse the row to match.
    document.addEventListener('menu-drawer:open', close);

    document.addEventListener('click', function (event) {
      if (!isOpen()) return;
      // The toggle's own click reaches this listener too — leaving it out here is
      // what stops it closing the row in the same gesture that opened it.
      if (search.contains(event.target) || toggle.contains(event.target)) return;
      close();
    });
  }

  document.querySelectorAll('[data-header-search-toggle]').forEach(init);
})();
